import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostVerificationValidate = () => {
  return useMutation({
    mutationFn: authService.postVerificationValidate,
    throwOnError: false,
  });
};
